module.exports = __webpack_public_path__ + "img/main_2_3.b4fd9867.png";